// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"561":"7f8a0b2f","672":"a0037973","685":"f84773b6","787":"be374c60"}[chunkId] + ".chunk.js";
};